<template>
  <div class="pk-ce__matrix-wrapper">
    <div class="pk-page-spacing-flex"></div>
    <div class="pk-ce__matrix-page">
      <div class="pk-ce__matrix-head">
        <div class="__row-1">
          <div class="pk-flex__00auto"
           style="margin-right:30px">
            <div class="pk-flex">
              <router-link :to="{path:'/ce/' + (currentCE ? currentCE.doc._id : '')}">
                <img src="../../assets/icons/criticaledition_introduction.svg"
                 style="height:30px;margin-right:5px">
              </router-link>
              <div class="pk-label">
                selected edition: <span v-if="currentCE && currentCE.doc">{{currentCE.doc._source['137_cetitle']}}</span>
              </div>
            </div>
          </div>
          <div class="pk-flex__1"></div>
          <div class="pk-flex__00auto">
            <div class="pk-label pk-flex">
              <div class="pk-flex__00auto"
               style="margin-right:10px">
                select sub-set
              </div>
              <select class="pk-flex__1"
               v-model="selectedComparison">
                <option :key="-2"
                 :value="-2"></option>
                <option :key="-1"
                 :value="-1">all collations</option>
                <option v-for="(cp,i) in comparisons" :key="i"
                 :value="i">{{cp._source['132_cptitle']}}</option>
              </select>
            </div>
          </div>

        </div>
        <div class="__row-2">
          <div class="pk-ce__matrix-line"></div>
          <div class="pk-flex__00auto pk-flex"
           style="margin-top:10px">
            <div class="pk-ce__matrix-leftsidebar">
              <div class="pk-ce__matrix-show-repeate-button"
               @click="showRepeatedSlides = !showRepeatedSlides">
                <span v-if="!showRepeatedSlides">show slides in performance order <br>(with repeated)</span>
                <span v-if="showRepeatedSlides">show slides in original order <br>(without repeated)</span>
              </div>
            </div>
            <div class="pk-ce__matrix-rightmain">
              <!-- <div v-for="i of slidesets[0].slides.length" :key="i" v-if="!showRepeatedSlides" -->
              <div v-for="i of slidesLength" :key="i" v-if="!showRepeatedSlides"
               class="__matrix-item">
                <span class="__number">{{i}}</span>
              </div>
              <div v-for="i of slidesPerformLength" :key="i" v-if="showRepeatedSlides"
               class="__matrix-item">
                <span class="__number">{{i}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pk-ce__matrix-body">
        <div v-for="(ss, i) of slidesets" v-if="!showRepeatedSlides"
         :key="'matrix-row'+i"
         class="__matrix-row">
          <div class="pk-ce__matrix-leftsidebar pk-flex">
            <div style="width:200px">
              <div class="pk-ce__matrix-sigle">
                {{ss.doc._source['54_sssigle']}}
              </div>
            </div>
            <div class="pk-flex__1">
              <div class="pk-ce__matrix-line"></div>
              <div style="text-align: center; margin-top:5px" 
                @click="showOrHideSlideset(ss)"
                :class="ss.showInMatrix ? '' : 'pk-hide-arrow'"
              >
                <div style="cursor: pointer;" :class="'fa-2x fas fa-caret-down'"></div>
              </div>
              <div style="text-align: center; margin-top:5px" 
                @click="showOrHideSlideset(ss)"
                :class="!ss.showInMatrix ? '' : 'pk-hide-arrow'"
              >
                <div style="cursor: pointer;" :class="'fa-2x fas fa-caret-right'"></div>
              </div>
            </div>
          </div>
          <div class="pk-ce__matrix-rightmain">
            <div v-for="(slide, j) of ss.slides" :key="j"
             class="__matrix-item">
              <div class="__matrix-item-bg"></div>
              <div :hidden="!ss.showInMatrix"
               class="__image-box">
                <div class="__image-wrapper">
                  <div class="__image-missing"
                   :class="slide.$_missing ? '' : 'pk-hide-div'">slide {{slide.$_position}} missing
                  </div>
                  <div v-if="selectedComparison === -1"
                   class="__image-overlay-wrapper">
                    <router-link v-for="(cpNum, cpNumIdx) of cpNumsOfSlide(slide)" 
                     :to="'./subset/'+comparisons[cpNum]._id" :key="cpNumIdx"
                     class="__image-overlay"
                     :style="overLayerStyles[cpNum].bg"
                     @mouseover.native="mouseoverSubSet(cpNum)"
                     @mouseleave.native="mouseoutSubSet(cpNum)"
                     :ref="'cpNum-' + cpNum">
                    </router-link>
                  </div>
                  <div v-if="selectedComparison > -1 && checkSlideInComprision(slide)"
                   class="__image-overlay-wrapper">
                    <router-link 
                     :to="'./subset/'+comparisons[selectedComparison]._id"
                     class="__image-overlay"
                     :style="getOverLayerStyle(slide)">
                    </router-link>
                  </div>
                  <div v-if="!slide.$_missing && getImageUrl(slide)"
                   class="__image-body">
                    <img :src="getImageUrl(slide)">
                  </div>
                  <div v-if="!slide.$_missing && !getImageUrl(slide)">No Image available</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(ss, i) of slidesets" v-if="showRepeatedSlides"
         :key="'matrix-row'+i"
         class="__matrix-row">
          <div class="pk-ce__matrix-leftsidebar pk-flex">
            <div style="width:200px">
              <div class="pk-ce__matrix-sigle">
                {{ss.doc._source['54_sssigle']}}
              </div>
            </div>
            <div class="pk-flex__1">
              <div class="pk-ce__matrix-line"></div>
              <div style="text-align: center; margin-top:5px" 
                @click="showOrHideSlideset(ss)"
                :class="ss.showInMatrix ? '' : 'pk-hide-arrow'"
              >
                <div style="cursor: pointer;" :class="'fa-2x fas fa-caret-down'"></div>
              </div>
              <div style="text-align: center; margin-top:5px" 
                @click="showOrHideSlideset(ss)"
                :class="!ss.showInMatrix ? '' : 'pk-hide-arrow'"
              >
                <div style="cursor: pointer;" :class="'fa-2x fas fa-caret-right'"></div>
              </div>
            </div>
          </div>
          <div class="pk-ce__matrix-rightmain">
            <div v-for="(slide, j) of ss.slidesPerform" :key="j"
             class="__matrix-item">
              <div class="__matrix-item-bg"></div>
              <div :hidden="!ss.showInMatrix"
               class="__image-box">
                <div class="__image-wrapper">
                  <div class="__image-missing"
                   :class="slide.$_missing ? '' : 'pk-hide-div'">slide {{slide.$_position}} missing
                  </div>
                  <div v-if="selectedComparison === -1"
                   class="__image-overlay-wrapper">
                    <router-link v-for="(cpNum, cpNumIdx) of cpNumsOfSlide(slide)" 
                     :to="'./subset/'+comparisons[cpNum]._id" :key="cpNumIdx"
                     class="__image-overlay"
                     :style="overLayerStyles[cpNum].bg"
                     @mouseover.native="mouseoverSubSet(cpNum)"
                     @mouseleave.native="mouseoutSubSet(cpNum)"
                     :ref="'cpNum-' + cpNum">
                    </router-link>
                  </div>
                  <div v-if="selectedComparison > -1 && checkSlideInComprision(slide)"
                   class="__image-overlay-wrapper">
                    <router-link 
                     :to="'./subset/'+comparisons[selectedComparison]._id"
                     class="__image-overlay"
                     :style="getOverLayerStyle(slide)">
                    </router-link>
                  </div>
                  <div v-if="!slide.$_missing && getImageUrl(slide)"
                   class="__image-body">
                    <img :src="getImageUrl(slide)">
                  </div>
                  <div v-if="!slide.$_missing && !getImageUrl(slide)" style="padding: 3px;"><span style="font-size: 11px;">No slide at this position of performance</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- matrix end -->
      </div>
    </div>
    <div class="pk-page-spacing-flex"></div>
  </div>
</template>

<script>

import Vue from 'vue';
import Util from '../../utils/util'; 

export default Vue.extend({
  data() {
    return {
      startLoad: {
        deepestReached: false,
        threads: []
      },
      timers: [],
      showRepeatedSlides: false,
      selectedComparison: -2,
      overLayerStyles: [
        {
          bg: 'background-color:#e6194b;',
          elems: [],
        },
        {
          bg: 'background-color:#3cb44b;',
          elems: [],
        },
        {
          bg: 'background-color:#ffe119;',
          elems: [],
        },
        {
          bg: 'background-color:#0082c8;',
          elems: [],
        },
        {
          bg: 'background-color:#f58231;',
          elems: [],
        },
        {
          bg: 'background-color:#911eb4;',
          elems: [],
        },
        {
          bg: 'background-color:#46f0f0;',
          elems: [],
        },
        {
          bg: 'background-color:#f032e6;',
          elems: [],
        },
        {
          bg: 'background-color:#d2f53c;',
          elems: [],
        },
        {
          bg: 'background-color:#fabebe;',
          elems: [],
        },
        {
          bg: 'background-color:#e6beff;',
          elems: [],
        },
        {
          bg: 'background-color:#aa6e28;',
          elems: [],
        },
        {
          bg: 'background-color:#800000;',
          elems: [],
        },
        {
          bg: 'background-color:#aaffc3;',
          elems: [],
        },
        {
          bg: 'background-color:#808000;',
          elems: [],
        },
        {
          bg: 'background-color:#ffd8b1;',
          elems: [],
        },
        {
          bg: 'background-color:#000080;',
          elems: [],
        },
        {
          bg: 'background-color:#880088;',
          elems: [],
        },
        {
          bg: 'background-color:#008888;',
          elems: [],
        },
        {
          bg: 'background-color:#000000;',
          elems: [],
        }
      ]
    };
  },

  created() {
    this.fetchData();
  },
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Critical Edition Matrix');
    }
    const resetSlidesOverlayProcessMarks = () => {
      for (const ss of this.slidesets) {
        if (ss) {
          for (const sl of ss.slides) {
            sl.ceMatrixOverLayerStylesProcessed = false;
          }
        }
      }
    };
    Util.checkStartLoad({
      loadingCount: 0,
      startLoad: this.startLoad,
      retryCondition: () => { 
        return this.startLoad.threads.length <= 0 || !this.startLoad.deepestReached;
      },
      allDoneCallback: () => {
        this.timers.push(setInterval(this.sortSlidesets, 2000));
        // add dummy slides in performance matrix
        let lenPerform = 0;
        for (const ss of this.slidesets) {
          if (ss && ss.slidesPerform && ss.slidesPerform.length > lenPerform) {
            lenPerform = ss.slidesPerform.length;
          }
        }
        for (const ss of this.slidesets) {
          if (ss && ss.slidesPerform && ss.slidesPerform.length < lenPerform) {
            const dif = lenPerform - ss.slidesPerform.length;
            for (let i = 0; i < dif; i++) {
              ss.slidesPerform.push({
                $_position: 10000,
                $_positionPerformList: [10000],
                $_missing: false,
                $_images: [],
                getActiveImage: () => {
                  return undefined;
                }
              });
            }
          }
        }
      }
    });
    if (this.slidesets) {
      resetSlidesOverlayProcessMarks();
    }
  },
  destroyed() {
    for (const timer of this.timers) {
      clearInterval(timer);
    }
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },

  computed: {
    criticalEditions() {
      return this.$store.state.criticalEditions;
    },
    currentCE() {
      if (this.criticalEditions) {
        const id = this.ceid;
        return this.criticalEditions.find(a => a.doc._id === id);
      }
      return;
    },
    ceid() {
      return this.$route.params.ceid;
    },
    slidesets() {
      return this.currentCE ? this.currentCE.slidesets : null;
    },
    comparisons() {
      return this.currentCE ? this.currentCE.comparisons : null;
    },
    slidesLength() {
      if (this.slidesets && this.slidesets[0]) {
        return this.slidesets[0].slides.length;
      } else {
        return 0;
      }
    },
    slidesPerformLength() {
      let ret = 0;
      if (this.slidesets) {
        for (const ss of this.slidesets) {
          if (ss && ss.slidesPerform && ss.slidesPerform.length > ret) {
            ret = ss.slidesPerform.length;
          }
        }
      }
      return ret;
    }
  },

  methods: {
    fetchData() {
      this.$store.dispatch('fetchCriticalEdition', {
        idArr: [this.ceid], 
        startLoad: this.startLoad, 
        cb: undefined
      });
    },
    sortSlidesets() {
      if (this.slidesets) {
        this.slidesets.sort((a, b) => {
          if (b.doc._source['54_sssigle'].indexOf('@nominal') > -1) {
            return 1;
          } else {
            return 0;
          }
        });
      }
    },
    showOrHideSlideset(ss) {
      ss.showInMatrix = !ss.showInMatrix;
    },
    getOverLayerStyle(slide) {
      if (!this.comparisons) {
        return '';
      }
      const cp = this.comparisons[this.selectedComparison];
      if (!cp) {
        return '';
      }
      const _id = slide._id;
      const c = cp._source['132_Items'].find(item => item.cpmasitem === _id);
      if (c) {
        return this.overLayerStyles[this.selectedComparison].bg;
      }
      return '';
    },
    cpNumsOfSlide(slide) {
      const ret = [];
      this.comparisons.forEach((cp, cpIdx) => {
        if (!cp) {
          return;
        }
        const c = cp._source['132_Items'].find(item => item.cpmasitem === slide._id);
        if (c) {
          ret.push(cpIdx);
        }
      });
      ret.sort((a, b) => {
        if (a > b) {
          return 1;
        } else {
          return -1;
        }
      });
      ret.forEach(a => {
        if (this.overLayerStyles[a]) {
          if (this.overLayerStyles[a].elems.indexOf(slide) < 0) {
            this.overLayerStyles[a].elems.push(slide);
          }
        }
      });
      slide.ceMatrixOverLayerStylesProcessed = true;
      return ret;
    },
    checkSlideInComprision(slide) {
      let ret = false;
      if (!this.comparisons) {
        return false;
      }
      if (!slide.ceMatrixOverLayerStylesProcessed) {
        this.cpNumsOfSlide(slide);
      }
      const st = this.overLayerStyles[this.selectedComparison];
      for (const elem of st.elems) {
        if (elem && elem._id === slide._id) {
          ret = true;
          break;
        }
      }
      return ret;
    },
    mouseoverSubSet(cpNum) {
      for (const link of this.$refs['cpNum-' + cpNum]) {
        link.$el.classList.add('__image-overlay-mouseover');
      }
    },
    mouseoutSubSet(cpNum) {
      for (const link of this.$refs['cpNum-' + cpNum]) {
        link.$el.classList.remove('__image-overlay-mouseover');
      }
    },
    getIcon(iconName) {
      return this.$getIcon(iconName);
    },

    getImageUrl(slide) {
      const image = slide.$_screenImage;
      if (image) {
        return image.dbImageInfo['thumbnail'];
      }
      return image;
    }

  }
});
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';

.pk-ce__matrix-wrapper {
  @extend .pk-flex;
  position: absolute;
  width: 100%;
  height: 100%;
  padding-top: 30px;
}

.pk-ce__matrix-page {
  @extend .pk-flex__1;
  @extend .pk-flex--column;
  position: relative;
}

.pk-ce__matrix-head {
  @extend .pk-flex__00auto;
  .__row-1 {
    @extend .pk-flex;
  }
  .__row-2 {
    margin-top: 35px;
    margin-bottom: 10px;
  }
}

.pk-ce__matrix-body {
  @extend .pk-flex__1;
  @extend .pk-flex--column;
  overflow: auto;
  padding-bottom: 20px;
  .__matrix-row {
    @extend .pk-flex__00auto;
    @extend .pk-flex;
    margin-top: 5px;
  }
}

.pk-ce__matrix-leftsidebar {
  width: 230px;

  .pk-ce__matrix-show-repeate-button {
    border:1px solid #A4B6DA;
    background-color: #A4B6DA;
    color: #FFF;
    border-radius: 2px;
    padding:2px 5px;
    font-size:10px;
    text-align: center;
  }
  .pk-ce__matrix-show-repeate-button:hover {
    cursor: pointer;
    background-color: rgb(92, 115, 161);
    color: #FFF;
  }
  .pk-ce__matrix-sigle {
    background-color:#DDDDDD;
    text-align: center;
    padding:10px 5px;
  }
}

.pk-ce__matrix-line {
  background-color: #DDDDDD;
  height: 8px;
}

.pk-ce__matrix-rightmain {
  @extend .pk-flex__1;
  @extend .pk-flex;
  .__matrix-item {
    text-align: center;
    width: 12.5%;
    .__number {
      border-radius:2px;
      background-color:#ddd;
      padding:0 8px;
    }
    .__matrix-item-bg {
      background-color:#DDDDDD;
      width:100%;
      height:8px;
      margin-bottom: 2px;
    }
    .__image-box {
      @extend .pk-flex;
      height: 100px;
      padding: 2px;
      .__image-wrapper {
        @extend .pk-flex__1;
        @extend .pk-flex__vh-center;
        background-color: #ccc;
        position: relative;
        .__image-overlay-wrapper {
          @extend .pk-flex;
          z-index: 100;
          position: absolute;
          height: 100%;
          width: 100%;
          .__image-overlay {
            @extend .pk-flex__1;
            opacity: 0.382;
          }
          .__image-overlay-mouseover {
            opacity: 0.618;
          }
        }
        .__image-body {
          width: 100%;
          height: 100%;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
        .__image-missing {
          color: #fff;
        }
      }
    }
  }
}

.pk-label {
  background-color: #d8dff2;
  padding: 5px 10px;
  height: 30px;
}
</style>